export default __webpack_public_path__ + "static/aws-mobile-ba88e3b6536a62b07db0e9badb94b7b5.jpg";